import { memo } from 'react';

import styles from '../FileIconChat.styles.m.css';

export const FileIconError = memo(() => {
  return (
    <>
      <circle
        className={styles.primaryColor}
        cx="39"
        cy="39"
        r="9"
      />
      <path
        className={styles.secondaryColor}
        d="M40 42C40 42.5523 39.5523 43 39 43C38.4477 43 38 42.5523 38 42C38 41.4477 38.4477 41 39 41C39.5523 41 40 41.4477 40 42ZM40 39C40 39.5523 39.5523 40 39 40C38.4477 40 38 39.5523 38 39V36C38 35.4477 38.4477 35 39 35C39.5523 35 40 35.4477 40 36V39Z"
      />
      <path
        className={styles.primaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.12 29.8855C43.6921 28.0247 44 26.0483 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C26.0483 44 28.0247 43.6921 29.8855 43.12C29.3167 41.8637 29 40.4688 29 39C29 33.4772 33.4772 29 39 29C40.4688 29 41.8637 29.3167 43.12 29.8855Z"
      />
      <path
        className={styles.secondaryColor}
        d="M31.5389 19.94C30.8766 18.7823 29.6443 17.6151 28.81 16.9C28.3341 16.4958 27.1146 15.4925 25.88 14.8429V19.63C25.88 19.8 26.02 19.94 26.19 19.94L31.5389 19.94Z"
      />
      <path
        className={styles.secondaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.88 14.25H23.21C20.95 14.25 19.3 14.25 18.2 14.41C17.21 14.55 16.42 15.48 16.3 16.66C15.9 20.64 15.9 27.1 16.3 31.07C16.4 32.04 17.04 32.88 17.97 33.26C19.17 33.75 21.41 33.75 24 33.75C27.07 33.75 29.01 33.71 30.06 33.25C30.99 32.84 31.6 32.02 31.7 31.07C31.9477 28.6203 31.9934 24.2177 31.9993 21.94L26.19 21.94C24.91 21.94 23.88 20.9 23.88 19.63V14.25Z"
      />
    </>
  );
});
